module.exports = __webpack_public_path__ + "img/3.9f93da14.png";